import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { PostHog as PostHogClient } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { PostHog } from './integrations/posthog';
import { initPostHogClient } from './integrations/posthogBootstrap';

import './styles/main.css';
import { initSentry } from './utils/sentry';

initSentry();

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 1000 * 60 * 5,
    },
  },
});

function renderApp(posthogClient: PostHogClient) {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <PostHog client={posthogClient}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </PostHog>
    </React.StrictMode>,
  );
}

const posthogClient = initPostHogClient();
renderApp(posthogClient);
